import { render, staticRenderFns } from "./giftCodeDetail.vue?vue&type=template&id=9da97190&scoped=true&"
import script from "./giftCodeDetail.vue?vue&type=script&lang=js&"
export * from "./giftCodeDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9da97190",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9da97190')) {
      api.createRecord('9da97190', component.options)
    } else {
      api.reload('9da97190', component.options)
    }
    module.hot.accept("./giftCodeDetail.vue?vue&type=template&id=9da97190&scoped=true&", function () {
      api.rerender('9da97190', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmToolNew/pack/components/giftCodeDetail.vue"
export default component.exports